export default __webpack_public_path__ + "static/media/icon5.29c4a506.svg";